<template>
  <div class="profile-detail-block modal-prof-detail">
    <div class="mb-2">
      <div class="d-flex flex-column">
        <div
          class="profile-img d-flex align-items-center justify-content-between"
        >
          <div class="d-flex flex-column">
            <h2 class="margin-bottom-0">
              <span
                class="mr-2"
                v-html="highlightText(['last_name'], profile.last_name)"
              ></span>
              <span v-html="highlightText(['full_name'], profile.name)"></span>
            </h2>
            <span class="margin-bottom-0">
              <span
                v-html="highlightText(['last_furigana'], profile.last_furigana)"
              ></span>
              &nbsp;
              <span
                v-html="highlightText(['furigana'], profile.furigana)"
              ></span>
              &nbsp;
            </span>
            <p style="word-break:break-all; color: #2F80ED" class="edit-txt">{{
              profile.email
            }}</p>

          </div>
        </div>
        <div class="d-flex flex-row justify-content-start gap-50">
          <div class="d-flex flex-column">
            <!-- <i class="fa fa-calendar-minus-o" aria-hidden="true"></i> -->
            <span class="edit-txt"
              >{{ profile.birthDate }} ( {{ profile.age }}歳 )</span
            >
            <span class="edit-txt">{{ profile.gender }}</span>
            <span class="edit-txt">{{ profile.residence.title }}</span>
          </div>
          <div class="company-from d-flex flex-column">
            <span class="edit-txt">{{ profile.education.last.title }}</span>
            <span class="edit-txt">{{ profile.education.instituteName }}</span>
            <span class="edit-txt">{{ profile.education.department }}</span>
            <span class="edit-txt"
              >{{ profile.education.graduateYear }} 年
              <span
                >{{ profile.education.graduateMonth || '' }} 月 卒業</span
              ></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyFrom from '../CompanyFrom.vue';
import EventParticipation from '../EventParticipation.vue';
export default {
  name: 'BasicInfo',
  components: {
    CompanyFrom,
    EventParticipation,
  },
  props: {
    profile: {
      required: true,
    },
    highlights: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
  computed: {
    companyFrom() {
      return this.profile.companyFrom == '自社HP経由';
    },
  },
  mounted() {
    this.$emit('basicLoaded');
  },
  methods: {
    copyTestingCode() {
      const testingCodeToCopy = document.querySelector('#testing-code');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line no-alert
      } catch (err) {
        console.log(err);
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    highlightText(paths, originalText) {
      if (!this.highlights || !this.highlights.length) {
        return originalText;
      }

      const highlights = this.highlights.filter((h) => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        let reconstructedText = '';
        for (let textPart of highlight.texts) {
          if (textPart.type === 'hit') {
            reconstructedText += `<mark>${textPart.value}</mark>`;
          } else {
            reconstructedText += textPart.value;
          }
        }

        if (
          highlightedText.includes(highlight.texts.map((t) => t.value).join(''))
        ) {
          highlightedText = highlightedText.replace(
            highlight.texts.map((t) => t.value).join(''),
            reconstructedText
          );
        }
      }

      return highlightedText;
    },
  },
};
</script>

<style scoped>

.gap-50 {
  gap:50px;
}

/deep/ mark {
  background-color: yellow;
  padding: 0px;
}
.highlight {
  background-color: yellow;
}
.modal-prof-detail.profile-detail-block {
  padding: 0px !important;
}

.modal-prof-detail .prf-title h1 {
  font-size: 24px;
  word-break: break-word;
}

.modal-prof-detail .prf-title h2 {
  font-size: 16px;
  word-break: break-word;
}

.modal-prof-detail .profile-desc ul li {
  font-size: 14px;
  margin-bottom: 7px;
}

.modal-prof-detail .profile-img {
  min-height: 85px;
}

.modal-prof-detail .profile-desc {
  padding-bottom: 0;
}

.copy-btn {
  font-weight: 100;
  padding: 2px 5px;
  border-radius: 5px !important;
  min-width: 74px !important;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: auto !important;
  height: 30px !important;
  background: #036d6c;
  border: 1px solid #036d6c;
  opacity: 0.9;
}
/* .company-from {
  position: absolute;
  bottom:0;
} */
</style>
